<template>
  <div class="container">
    <div class="notice-content">
      <div class="notice-item" v-for="(item, index) in notices" :key="index" @click="viewNoticeDetail(item)">
        <div class="notice-title">{{ decryptLabel(item.title) }}</div>
        <div class="notice-date">{{ item.date }}</div>
      </div>
    </div>
    
    <button class="back-btn" @click="goBack">返回</button>
  </div>
</template>

<script>
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      notices: [
        { id: 1, title: 'qTLrwxK8TFwM8ApMHTtn/RZ9kpWRSQPTQNkwKXR/v/6qzH3B1/Qz+XLTwf43fXEx', date: '2023-05-15' },
        { id: 2, title: 'UQxQP4B5bQveOpyXwHEnwCOBrmESSmzRLmqwSk7LanE=', date: '2023-05-10' },
        { id: 3, title: 'QQ45qiljUndupW49hkvV5V+woaIslEjoYxr0l/4fy+g=', date: '2023-05-05' },
        { id: 4, title: 'KmUHKgwR1QzIEEQDwe7MTu8wjoAprIUDSuOS7lYX0MI=', date: '2023-04-25' },
        { id: 5, title: 'SoSd3jfpZdGHOUm0RXn83yGi8t2ei64GAb79r/O+xD4=', date: '2023-04-20' }
      ]
    }
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    viewNoticeDetail(item) {
      this.$router.push(`/notice-detail?id=${item.id}`)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.notice-content {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}

.notice-item:last-child {
  border-bottom: none;
}

.notice-title {
  font-size: 15px;
  color: #333;
  flex: 1;
}

.notice-date {
  font-size: 12px;
  color: #999;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
</style>
